import React, {useState} from "react";
import {observer} from "mobx-react";
import {IPassengerViewModel} from "../../../../../services/booking/models/passenger/passenger-view-model.interface";
import {IonToggle} from "@ionic/react";
import {useServices} from "../../../../../hooks/use-services.hook";
import {WheelchairIcon} from "../../../../../assets/svg/wheelchair.icon";
import {
    IconBox,
    LabelAndIconContainerBox,
    LabelBox,
    ToggleContainerBox
} from "../boxes/passenger-property-toggle.boxes";
import {LineBox} from "../boxes/passenger-properties-spearator-line.box";



export const ReducedMobilitySsrToggleComponent: React.FC<{passenger: IPassengerViewModel; renderLine?: boolean}> = observer((props) => {
    const services = useServices();
    const booking = services.booking.current;

    const [ssrsAggregator] = useState(booking.createSsrsAggregator({
        ssrTypes: [services.ssrTypes.PRMP],
        onlyForPassengers: () => [props.passenger],
    }));

    ssrsAggregator.useSameOptionsForAllFlights = true;

    if(!props.passenger.allowPsoReducedMobility) {
        return null;
    }

    if(!ssrsAggregator.canBeModifiedForAllFlightsAndAllPassengers) {
        return null;
    }

    const toggleSsrQuantity = () => {
        let newQuantity: number;
        if(ssrsAggregator.totalSsrsQuantity > 0) {
            newQuantity = 0;
        } else {
            newQuantity = 1;
        }
        ssrsAggregator.journeysSsrsBuckets.forEach((bucket) => {
            bucket.getAllSsrsInTheBucket().forEach(ssr => {

                ssr.applySameQuantityForAllPassengers(newQuantity);
            });
        });
    }

    const onLabelClick = () => {
        toggleSsrQuantity();
    }


    return (
        <>
            <ToggleContainerBox>
                <LabelAndIconContainerBox onClick={onLabelClick}>
                    <IconBox>
                        <WheelchairIcon size={1.5}/>
                    </IconBox>

                    <LabelBox>
                        {booking.pso.getReducedMobilitySsrTranslation()}
                    </LabelBox>
                </LabelAndIconContainerBox>

                <IonToggle checked={ssrsAggregator.totalSsrsQuantity > 0}
                           onIonChange={() => toggleSsrQuantity()}/>
            </ToggleContainerBox>
            {props.renderLine && <LineBox/>}
        </>

    );
})